import {
  ArrowRightIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  NotAllowedIcon,
  RepeatClockIcon,
} from "@chakra-ui/icons";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { FiFilter } from "react-icons/fi";
import { readingOrderStatus } from "../../../core/constants";

const ReadingStatusFilter = ({
  selectedFilter,
  setSelectedFilter,
  disabled,
}) => {
  return (
    <Menu mr="3">
      <MenuButton
        as={Button}
        leftIcon={<FiFilter size={14} />}
        rightIcon={<ChevronDownIcon />}
        size="sm"
        isDisabled={disabled}
      >
        {readingOrderStatus[selectedFilter]}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => setSelectedFilter("all")}>Show All</MenuItem>
        <MenuItem
          onClick={() => setSelectedFilter("unread")}
          icon={<NotAllowedIcon />}
        >
          Unread
        </MenuItem>
        <MenuItem
          onClick={() => setSelectedFilter("read")}
          icon={<CheckCircleIcon />}
        >
          Read
        </MenuItem>
        <MenuItem
          onClick={() => setSelectedFilter("skipped")}
          icon={<ArrowRightIcon />}
        >
          Skipped
        </MenuItem>
        <MenuItem
          onClick={() => setSelectedFilter("readLater")}
          icon={<RepeatClockIcon />}
        >
          Read later
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ReadingStatusFilter;
